import { render, staticRenderFns } from "./InstanceItemActions.vue?vue&type=template&id=4f0d1da4&scoped=true"
import script from "./InstanceItemActions.vue?vue&type=script&lang=js"
export * from "./InstanceItemActions.vue?vue&type=script&lang=js"
import style0 from "./InstanceItemActions.vue?vue&type=style&index=0&id=4f0d1da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0d1da4",
  null
  
)

export default component.exports